import {
  NewOrderImpressionsMode,
  TBaseKeyword,
  TNewOrderCountry,
  TViewsKeyword,
} from "@/entities/new-order";
import { getDatesListFromCountry } from "@/entities/new-order/utils/get-dates-list-from-country";
import { getKeysFromCountry } from "@/entities/new-order/utils/get-keys-from-country";

export function parseKeywordsToViews(countries: TNewOrderCountry[]) {
  const newCountries: TNewOrderCountry[] = countries.map((country) => {
    const oldKeywords: TBaseKeyword = country.keywords as TBaseKeyword;
    const newKeywords: TViewsKeyword = {};

    // Проверяем, что keywords существует и не пустой
    if (!oldKeywords || typeof oldKeywords !== "object") {
      return {
        ...country,
        impressions: { type: NewOrderImpressionsMode.CR },
        keywords: newKeywords,
      };
    }

    const datesList = getDatesListFromCountry(country);
    const keysList = getKeysFromCountry(country);

    // Если нет дат или ключей, возвращаем страну с пустыми keywords
    if (datesList.length === 0 || keysList.length === 0) {
      return {
        ...country,
        impressions: { type: NewOrderImpressionsMode.CR },
        keywords: newKeywords,
      };
    }

    // Преобразуем старый формат в новый с views и CR
    datesList.forEach((date) => {
      keysList.forEach((key) => {
        if (!newKeywords[date]) {
          newKeywords[date] = {};
        }
        newKeywords[date][key] = {
          installs: oldKeywords[date]?.[key] ?? 0,
          views: 0,
          CR: 100,
        };
      });
    });

    return {
      ...country,
      impressions: { type: NewOrderImpressionsMode.CR },
      keywords: newKeywords,
    };
  });

  return newCountries;
}
